import { Grid } from '@lingoda/ui/layout/GridNext';
import { RecapAchievementsBoardItem } from './RecapAchievementsBoardItem';

export const RecapAchievementsBoard = () => {
    return (
        <Grid container spacing={{ xs: 2, sm: 3 }} data-cy="Recap achievements board">
            <Grid xs={6} sm={4} md={3}>
                <RecapAchievementsBoardItem />
            </Grid>
        </Grid>
    );
};
